
export default {
  colors: {
    main_1: '#e20840', // red
    main_2: '#fff', // white
    main_3: '#a2a2a2', // grey
    main_4: '#f5a623', // yellow
    main_5: '#7ed321', // green
    secondary_3a: '#efefef', // light-grey
    secondary_3b: '#7d7d7d', // dark-grey
    secondary_3c: '#353535', // very-dark-grey
  },
  ratio: {
    icon: (4 / 10),
    tile: (4 / 3),
  },
  shadow: {
    initial: '0px 0px 10px 0px rgba(0,0,0,0.2)',
    hover: '0px 0px 10px 2px rgba(0,0,0,0.2)',
  },
  speed: {
    superFast: 40,
    veryFast: 150,
    fast: 300,
    medium: 600,
    slow: 900,
  },
  sizes: {
    container: 1000,
    smallContainer: 450,
    gutter: 30,
    header: 130,
    headerLarge: 160,
    layoutImage: 200,
    footer: 60,
    footerLarge: 80,
    footerExpanded: 120,
    footerExpandedLarge: 160,
  },
  media: {
    medium: '@media (min-width: 540px)',
    large: '@media (min-width: 960px)',
  },
  motion: {
    standard: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
    deceleration: 'cubic-bezier(0.0, 0.0, 0.2, 1)',
    acceleration: 'cubic-bezier(0.4, 0.0, 1, 1)',
    sharp: 'cubic-bezier(0.4, 0.0, 0.6, 1)',
  },
}



// WEBPACK FOOTER //
// ./src/utils/theme.js